import React from "react"
import { connect } from "react-redux"
import { Container, Row, Col } from "reactstrap"

const CaseStudyArchive = ({ mobile, archived }) => {
  archived = archived.map((j, index) => {
    if (j.clientName === "Forty Seven Brand") {
      j.width = mobile ? "40px" : "65px";
    } else if (j.clientName === "ACG Nike") {
      j.width = mobile ? "40px" : "65px";
    } else if (j.clientName === "Adidas") {
      j.width = mobile ? "58px" : "78px";
    } else if (j.clientName === "Airwalk") {
      j.width = mobile ? "60px" : "80px";
    } else if (j.clientName === "Allbirds") {
      j.width = mobile ? "60px" : "80px";
    } else if (j.clientName === "Bose") {
      j.width = mobile ? "60px" : "95px";
    } else if (j.clientName === "Burton") {
      j.width = mobile ? "35px" : "50px";
    } else if (j.clientName === "Champions") {
      j.width = mobile ? "40px" : "55px";
    } else if (j.clientName === "Clarks") {
      j.width = mobile ? "50px" : "70px";
    } else if (j.clientName === "Coca Cola") {
      j.width = mobile ? "50px" : "70px";
    } else if (j.clientName === "Cole Haan") {
      j.width = mobile ? "65px" : "93px";
    } else if (j.clientName === "Complex") {
      j.width = mobile ? "50px" : "70px";
    } else if (j.clientName === "Converse") {
      j.width = mobile ? "50px" : "70px";
    } else if (j.clientName === "Dell") {
      j.width = mobile ? "60px" : "78px";
    } else if (j.clientName === "Drmartens") {
      j.width = mobile ? "50px" : "70px";
    } else if (j.clientName === "Extra Butter") {
      j.width = mobile ? "50px" : "77px";
    } else if (j.clientName === "Fader") {
      j.width = mobile ? "50px" : "94px";
    } else if (j.clientName === "Fossil") {
      j.width = mobile ? "65px" : "75px";
    } else if (j.clientName === "Fragment") {
      j.width = mobile ? "35px" : "64px";
    } else if (j.clientName === "Google") {
      j.width = mobile ? "55px" : "60px";
    } else if (j.clientName === "HBO") {
      j.width = mobile ? "45px" : "70px";
    } else if (j.clientName === "Herschel") {
      j.width = mobile ? "40px" : "90px";
    } else if (j.clientName === "Honda") {
      j.width = mobile ? "50px" : "60px";
    } else if (j.clientName === "Hypebeast") {
      j.width = mobile ? "58px" : "85px";
    } else if (j.clientName === "Intel") {
      j.width = mobile ? "60px" : "90px";
    } else if (j.clientName === "Jordan") {
      j.width = mobile ? "40px" : "70px";
    } else if (j.clientName === "KYX") {
      j.width = mobile ? "60px" : "72px";
    } else if (j.clientName === "Levis") {
      j.width = mobile ? "50px" : "70px";
    } else if (j.clientName === "LVMH") {
      j.width = mobile ? "50px" : "70px";
    } else if (j.clientName === "Medicom") {
      j.width = mobile ? "30px" : "50px";
    } else if (j.clientName === "Miller") {
      j.width = mobile ? "50px" : "70px";
    } else if (j.clientName === "Neiman Marcus") {
      j.width = mobile ? "50px" : "77px";
    } else if (j.clientName === "New Balance") {
      j.width = mobile ? "50px" : "70px";
    } else if (j.clientName === "Nike") {
      j.width = mobile ? "50px" : "60px";
    } else if (j.clientName === "Oakley") {
      j.width = mobile ? "50px" : "54px";
    } else if (j.clientName === "Overwatch") {
      j.width = mobile ? "40px" : "50px";
    } else if (j.clientName === "Puma") {
      j.width = mobile ? "50px" : "86px";
    } else if (j.clientName === "Raleigh") {
      j.width = mobile ? "60px" : "70px";
    } else if (j.clientName === "Reebok") {
      j.width = mobile ? "50px" : "70px";
    } else if (j.clientName === "Rtfkt") {
      j.width = mobile ? "80px" : "98px";
    } else if (j.clientName === "Shake-Shack") {
      j.width = mobile ? "85px" : "125px";
    } else if (j.clientName === "Shantell-Martin") {
      j.width = mobile ? "75px" : "95px";
    } else if (j.clientName === "Sherwood") {
      j.width = mobile ? "72px" : "95px";
    } else if (j.clientName === "Skechers") {
      j.width = mobile ? "60px" : "78px";
    } else if (j.clientName === "Sneaker Con") {
      j.width = mobile ? "50px" : "86px";
    } else if (j.clientName === "Sprite") {
      j.width = mobile ? "50px" : "77px";
    } else if (j.clientName === "Spunge") {
      j.width = mobile ? "75px" : "110px";
    } else if (j.clientName === "Starter") {
      j.width = mobile ? "40px" : "45px";
    } else if (j.clientName === "Timberland") {
      j.width = mobile ? "58px" : "86px";
    } else if (j.clientName === "Topps") {
      j.width = mobile ? "55px" : "70px";
    } else if (j.clientName === "Tretorn") {
      j.width = mobile ? "57px" : "77px";
    } else if (j.clientName === "Tumi") {
      j.width = mobile ? "75px" : "90px";
    } else if (j.clientName === "Uber") {
      j.width = mobile ? "75px" : "90px";
    } else if (j.clientName === "Zeedog") {
      j.width = mobile ? "30px" : "45px";
    } else if (j.clientName === "MLS") {
      j.width = mobile ? "30px" : "50px";
    } else if (j.clientName === "NY Rangers") {
      j.width = mobile ? "30px" : "50px";
    } else if (j.clientName === "Netflix") {
      j.width = mobile ? "57px" : "77px";
    } else if (j.clientName === "Crocs") {
      j.width = mobile ? "57px" : "77px";
    } else if (j.clientName === "Stapleverse") {
      j.width = mobile ? "57px" : "77px";
    } else if (j.clientName === "Team Ikuzawa") {
      j.width = mobile ? "57px" : "77px";
    } else if (j.clientName === "Rizzoli") {
      j.width = mobile ? "57px" : "65px";
    }
    return j;
  });
  archived = archived.sort((a, b) => a.clientName.localeCompare(b.clientName))
  let archivedData = archived.length > 0 && archived.map((i, idx) => {
    return (
      <Col key={idx} xs="3" md="2" className="d-flex justify-content-center align-items-center my-3">
        {i.logo.fluid === null ?
          <img src={i.logo.file.url} alt={i.clientName} width={i.width} /> :
          <img src={i.logo.fluid.src} alt={i.clientName} width={i.width} /> }
      </Col>
    )
  })
  return (
    <Container fluid id="caseStudyArchive">
      <Row className="d-flex justify-content-center">
        {archivedData}
      </Row>
    </Container>
  )
}

export default connect(
  state => ({
    mobile: state.global.mobile,
  }),
  null
)(CaseStudyArchive)
